import Drawer from 'material-ui/Drawer';
import moment from 'moment';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import HttpStatus from 'http-status-codes';
import { withTranslation } from 'react-i18next';
import { asyncRequest, Entities, Projection, TOMCAT_URL, UserRole } from 'src/common/index';
import PasswordEditModal from 'src/components/account/password-edit-modal';
import AdminCustomerVerificationModal from 'src/components/admin/accounts/admin-customer-verification-modal';
import AdminCustomerContactForm from 'src/components/admin/accounts/AdminCustomerContactForm';
import ConfirmDialog from 'src/components/misc/confirm-dialog';
import ErrorMessage from 'src/components/misc/error-message';
import ParentForm from 'src/components/misc/parent-form';
import { ButtonColors, CustomerGroupType, genderName } from 'src/utils/constants';
import composeModalActions from 'src/utils/modal-action-wrapper';
import TableHelper from 'src/utils/table-helper';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import { Toggle } from 'material-ui';

class AdminCustomerAdministration extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            drawer: {
                open: false,
                selectedRow: undefined,
            },
            includeImportedByCustomers: false,
            startedFetching: false,
        };

        this.tableHelper = new TableHelper({ onRowClick: this.onRowClick });
    }

    componentWillMount() {
        // this.props.fetchAll(Entities.CUSTOMER, 0, Projection.DETAILS);
        this.props.fetchAllCustomRepository(Entities.CUSTOMER, 'get-customers', this.getQueryParams());
    }

    createCustomToolBar(props) {
        const { t } = this.props;

        return (
            <>
                <div className="col-md-12">
                    <div className="col-md-3">
                        <Toggle
                            label={t('customer_details.filter.included_imported_customers')}
                            toggled={this.state.includeImportedByCustomers}
                            onToggle={() => {
                                this.setState({ includeImportedByCustomers: !this.state.includeImportedByCustomers });
                            }}
                        />
                    </div>
                    <div className="col-md-6">
                        <div style={{ marginRight: 'auto' }}>
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={() => {
                                    if (this.table) {
                                        this.table.handleExportCSV();
                                    }
                                }}>
                                {t('common_phrases.export_list')}
                            </button>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div>{props.components.searchPanel}</div>
                    </div>
                </div>
            </>
        );
    }

    getQueryParams() {
        const queryParams = [];

        queryParams.push(`includeImportedByCustomers=${this.state.includeImportedByCustomers}`);
        return queryParams.join('&');
    }

    shouldComponentUpdate(nextProps) {
        return !nextProps.modal.open;
    }

    componentWillReceiveProps(nextProps) {
        const { customers } = nextProps;

        if (!this.state.startedFetching && customers.isFetching) this.setState({ startedFetching: true });

        this.tableHelper.processPagination(customers.items.length);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.tableHelper.processPaginationAfterUpdate(prevProps.customers, this.props.customers, this.table))
            this.setState({ renderSelection: !this.state.renderSelection });

        if (prevState.includeImportedByCustomers !== this.state.includeImportedByCustomers) {
            this.props.fetchAllCustomRepository(Entities.CUSTOMER, 'get-customers', this.getQueryParams());
        }
    }

    render() {
        const { customers, t } = this.props;
        const finishFetching = this.state.startedFetching && !customers.isFetching;

        const tableData = [];

        if (finishFetching) {
            customers.items.map(account => {
                tableData.push({
                    id: account.id,
                    email: account.email,
                    fullName: account.contactData.fullName,
                    gender: account.contactData.gender,
                    address: account.contactData.address,
                    registered: account.registered,
                    verified: account.verified,
                    verifiedAt: account.verifiedAt,
                    verifiedBy: account.verifiedBy,
                    verificationComment: account.verificationComment,
                    subscribedToNewsletter: account.subscribedToNewsletter,
                    organizationName: account.organizationName,
                    organizationLocation: account.organizationLocation && account.organizationLocation.address,
                    customerGroup: account.customerGroup,
                    customerGroupName: account.customerGroup ? t(`customer_groups.id.${account.customerGroup.id}`) : '',
                    entity: account,
                    apiCustomer: account.apiCustomer,
                    registeredAt: account.registeredAt,
                    firstName: account.contactData.firstName,
                    lastName: account.contactData.lastName,
                    postCode: account.contactData.postCode,
                    place: account.contactData.city,
                    country: account.contactData.country,
                    eduplacesId: account.eduplacesId,
                    importedBy: account.importedByCompanyId,
                });
            });
        }

        return (
            <div>
                <legend className="legend">{t('customer_details.customer')}</legend>

                {(() => {
                    if (customers.error) return <ErrorMessage object={customers} />;
                    else
                        return (
                            <div>
                                <Drawer
                                    openSecondary={true}
                                    docked={false}
                                    width={400}
                                    onRequestChange={open =>
                                        this.setState({
                                            drawer: {
                                                open: false,
                                                selectedRow: undefined,
                                            },
                                        })
                                    }
                                    open={this.state.drawer.open}>
                                    {this.state.drawer.open && this.state.drawer.selectedRow
                                        ? renderCustomerDetails(
                                              t,
                                              this.state.drawer.selectedRow.entity,
                                              this.state.drawer.selectedRow.entity.contactData,
                                          )
                                        : null}
                                </Drawer>

                                <BootstrapTableErrorBoundary>
                                    <BootstrapTable
                                        ref={ref => (this.table = ref)}
                                        data={tableData}
                                        exportCSV={true}
                                        striped={true}
                                        hover={true}
                                        condensed={true}
                                        pagination={true}
                                        options={Object.assign(
                                            { toolBar: this.createCustomToolBar, clearSearch: true },
                                            this.tableHelper.getOptions(finishFetching),
                                        )}
                                        selectRow={Object.assign({}, this.tableHelper.getRowProps())}
                                        searchPlaceholder={t('common_phrases.search')}
                                        search={true}>
                                        <TableHeaderColumn
                                            columnTitle={true}
                                            dataField="id"
                                            hidden={true}
                                            isKey={true}
                                            export={true}>
                                            {t('common_phrases.id')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            columnTitle={true}
                                            dataField="email"
                                            width="200"
                                            dataSort={true}>
                                            {t('contact_data.username')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            columnTitle={true}
                                            dataField="customerGroupName"
                                            width="140"
                                            dataSort={true}>
                                            {t('customer_details.customer_group')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            columnTitle={true}
                                            dataField="organizationName"
                                            width="180"
                                            dataSort={true}>
                                            {t('customer_details.organisation')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            columnTitle={true}
                                            dataField="gender"
                                            dataSort={true}
                                            width="60"
                                            dataFormat={cell => genderName(t, cell)}
                                            csvFormat={cell => genderName(t, cell)}>
                                            {t('contact_data.gender')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            columnTitle={true}
                                            dataField="fullName"
                                            width="180"
                                            dataSort={true}>
                                            {t('common_phrases.name')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn columnTitle={true} dataField="address" dataSort={true}>
                                            {t('customer_details.address')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            columnTitle={true}
                                            dataField="registeredAt"
                                            width="110"
                                            dataSort={true}
                                            dataFormat={(date, row) =>
                                                row.registered ? dateFormatterShort(date, t) : ''
                                            }
                                            csvFormat={(date, row) =>
                                                row.registered ? dateFormatterShort(date, t) : ''
                                            }>
                                            {t('contact_data.registration_date')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            dataField="registered"
                                            width="80"
                                            dataSort={true}
                                            dataFormat={registerEduplacesStatusFormatter(t)}>
                                            {t('customer_details.registered')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            dataField="verified"
                                            width="80"
                                            dataSort={true}
                                            dataFormat={verifiedFormatter(t)}>
                                            {t('customer_details.verified')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            dataField="subscribedToNewsletter"
                                            width="80"
                                            dataSort={true}
                                            dataFormat={statusFormatter}>
                                            {t('customer_details.newsletter')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            dataField="actions"
                                            width="120"
                                            dataFormat={this.tableActionsFormatter}
                                            export={false}>
                                            {t('common_phrases.actions')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            dataField="firstName"
                                            width="80"
                                            hidden={true}
                                            export={true}
                                            csvHeader="firstname"></TableHeaderColumn>
                                        <TableHeaderColumn
                                            dataField="lastName"
                                            width="80"
                                            hidden={true}
                                            export={true}
                                            csvHeader="name"></TableHeaderColumn>
                                        <TableHeaderColumn
                                            dataField="postCode"
                                            width="80"
                                            hidden={true}
                                            export={true}
                                            csvHeader="zip_plz"></TableHeaderColumn>
                                        <TableHeaderColumn
                                            dataField="city"
                                            width="80"
                                            hidden={true}
                                            export={true}
                                            csvHeader="place_ort"></TableHeaderColumn>
                                        <TableHeaderColumn
                                            dataField="country"
                                            csvHeader="country_land"
                                            hidden={true}
                                            export={true}></TableHeaderColumn>
                                        <TableHeaderColumn
                                            dataField="eduplacesId"
                                            width="80"
                                            dataSort={true}
                                            hidden={true}
                                            export={true}>
                                            {t('customer_details.eduplaces_id')}
                                        </TableHeaderColumn>
                                        <TableHeaderColumn
                                            dataField="importedBy"
                                            width="80"
                                            dataSort={true}
                                            hidden={true}
                                            export={true}>
                                            {t('customer_details.imported_by')}
                                        </TableHeaderColumn>
                                    </BootstrapTable>
                                </BootstrapTableErrorBoundary>
                            </div>
                        );
                })()}
            </div>
        );
    }

    tableActionsFormatter(cell, account) {
        const { addNotification, t } = this.props;
        return (
            <div>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    onClick={() => {
                        this.props.openModal({
                            component: ParentForm,
                            componentProps: {
                                isCreate: false,
                                mainEntityProps: {
                                    entity: Entities.CUSTOMER,
                                    id: account.id,
                                },
                                projection: Projection.DETAILS,
                                childForm: {
                                    component: AdminCustomerContactForm,
                                },
                                closeDrawer: this.handleCloseDrawer,
                            },
                            title: account.email,
                        });
                    }}>
                    <span className="glyphicon glyphicon-pencil text-info" />
                </button>
                {!account.verified && (
                    <button
                        type="button"
                        className="btn btn-xs transparent"
                        title={t('customer_details.verify')}
                        onClick={() => {
                            this.props.openModal({
                                cancelCallback: this.handleCloseDrawer,
                                component: AdminCustomerVerificationModal,
                                componentProps: {
                                    id: account.id,
                                    closeDrawer: this.handleCloseDrawer,
                                },
                                title: t('customer_details.verify_client', { email: account.email }),
                                mandatoryFields: true,
                            });
                        }}>
                        <span className="glyphicon glyphicon-check text-success" />
                    </button>
                )}
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    title={t('customer_details.change_password')}
                    onClick={() => {
                        this.props.openModal({
                            component: PasswordEditModal,
                            cancelCallback: this.handleCloseDrawer,
                            componentProps: {
                                id: account.id,
                                role: UserRole.CUSTOMER,
                                isAdmin: true,
                                closeDrawer: this.handleCloseDrawer,
                            },
                            title: t('customer_details.change_password_client', { fullName: account.fullName }),
                            mandatoryFields: true,
                        });
                    }}>
                    <span className="glyphicon glyphicon-lock text-info" />
                </button>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    title={t('customer_details.password_reset_link')}
                    onClick={() => {
                        this.props.openModal({
                            component: ConfirmDialog,
                            componentProps: {
                                closeDrawer: this.handleCloseDrawer,
                                bodyText: t('customer_details.confirm_password_reset_link'),
                                proceedText: t('user_functionality.send'),
                                cancelText: t('common_phrases.no'),
                                cancelCallback: this.handleCloseDrawer,
                                cancelButtonColor: ButtonColors.NOTIFY,
                                proceedButtonColor: ButtonColors.DANGER,
                                event: account.email,
                                onProceedDialog: email =>
                                    asyncRequest({
                                        method: 'POST',
                                        endpoint: `${TOMCAT_URL}api/admin/send-password-reset-link`,
                                        body: {
                                            email,
                                        },
                                    })
                                        .then(response =>
                                            addNotification(
                                                t('customer_details.sent'),
                                                t('customer_details.sent_password_reset_link'),
                                                'success',
                                                'tr',
                                            ),
                                        )
                                        .catch(error =>
                                            addNotification(
                                                t('common_phrases.error'),
                                                t('customer_details.error_email_sending'),
                                                'error',
                                                'tr',
                                            ),
                                        ),
                            },
                            title: t('customer_details.reset_link_customer', { email: account.email }),
                            noButtons: true,
                        });
                    }}>
                    <span className="glyphicon glyphicon-refresh text-info" />
                </button>
                {!account.registered && (
                    <button
                        type="button"
                        className="btn btn-xs transparent"
                        title={t('customer_details.registration_email.send')}
                        onClick={() => {
                            this.props.openModal({
                                component: ConfirmDialog,
                                componentProps: {
                                    closeDrawer: this.handleCloseDrawer,
                                    cancelCallback: this.handleCloseDrawer,
                                    proceedText: t('user_functionality.send'),
                                    cancelText: t('common_phrases.no'),
                                    cancelButtonColor: ButtonColors.DANGER,
                                    proceedButtonColor: ButtonColors.NOTIFY,
                                    bodyText: t('customer_details.registration_email.body'),
                                    event: account.email,
                                    onProceedDialog: email =>
                                        asyncRequest({
                                            method: 'POST',
                                            endpoint: `${TOMCAT_URL}api/admin/send-registration-reminder-email`,
                                            body: {
                                                email,
                                            },
                                        })
                                            .then(response =>
                                                addNotification(
                                                    t('customer_details.sent'),
                                                    t('customer_details.sent_confirmation_email'),
                                                    'success',
                                                    'tr',
                                                ),
                                            )
                                            .catch(error => {
                                                if (error.status === HttpStatus.CONFLICT) {
                                                    return addNotification(
                                                        t('common_phrases.error'),
                                                        t(
                                                            'customer_details.registration_email.authentication_disabled',
                                                        ),
                                                        'error',
                                                        'tr',
                                                    );
                                                }

                                                addNotification(
                                                    t('common_phrases.error'),
                                                    t('customer_details.error_email_sending'),
                                                    'error',
                                                    'tr',
                                                );
                                            }),
                                },
                                title: t('customer_details.registration_email.title', { email: account.email }),
                                noButtons: true,
                            });
                        }}>
                        <span className="glyphicon glyphicon-envelope text-info" />
                    </button>
                )}
            </div>
        );
    }

    onRowClick(row) {
        this.tableHelper.setSelectedRow(row.entity.id);
        this.setState({
            drawer: {
                open: !this.state.drawer.open,
                selectedRow: row,
            },
        });
    }

    handleCloseDrawer() {
        this.setState({
            drawer: {
                open: !this.state.drawer.open,
                selectedRow: undefined,
            },
        });
    }
}

export default composeModalActions(withTranslation()(AdminCustomerAdministration));

const dateFormatter = (date, t) => {
    return date ? t('administration.time', { time: moment(date).format() }) : '-';
};

export const eduplacesFormatter = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={19} viewBox="0 0 115.3 79.44">
            <defs></defs>
            <g>
                <path
                    className="cls-1"
                    d="m115.28,33.48c-.51-7.52-10.05-10.35-22.19-11.13C86.71,8.31,72.12-1.01,55.82.09c-16.24,1.1-29.4,12.21-33.88,26.9C9.32,29.35-.51,33.46.02,41.28h0c.52,7.75,10.69,11.1,23.4,12.32,3.79,8.9,10.98,15.97,19.88,19.76-.08.38-.12.78-.12,1.18,0,3.27,2.65,5.93,5.93,5.93,2.68,0,4.94-1.78,5.67-4.21,2.03.19,4.1.22,6.2.07,16.74-1.13,30.21-12.74,34.23-27.83,11.71-2.94,20.58-7.55,20.08-15h0s0,0,0,0Zm-54.83,35.08c-11.69.79-22.29-5.12-28.04-14.45.98.03,1.97.04,2.97.05,8.15.08,16.44-.35,23.35-.82h0c7.32-.5,16.17-1.23,24.68-2.55.99-.15,1.97-.31,2.94-.48-4.41,10.09-14.15,17.45-25.91,18.24Zm43.45-35.24h0c.16,2.41-2.8,4.29-7.46,5.79-2.22.71-4.84,1.33-7.68,1.88-9.28,1.78-21.05,2.75-29.94,3.35h0c-8.89.6-20.68,1.23-30.12.71-2.89-.16-5.57-.42-7.86-.83-4.81-.85-8.01-2.32-8.17-4.73h0c-.17-2.47,2.97-4.28,7.86-5.63-.14,1.25-.22,2.51-.23,3.79,1.93.69,4.57,1.14,7.61,1.43-.53-16.35,11.99-30.3,28.44-31.41,16.45-1.11,30.73,11.03,32.4,27.3,2.98-.69,5.53-1.49,7.35-2.44-.19-1.27-.44-2.51-.74-3.73,5.03.68,8.38,2.05,8.55,4.52h0Z"
                />
                <path
                    className="cls-1"
                    d="m66.33,33.18c-.03-.13-.05-.27-.09-.4-.01-.04-.03-.08-.04-.11-.04-.13-.08-.26-.13-.39-.01-.03-.03-.05-.04-.08-.06-.14-.12-.27-.19-.4,0-.02-.02-.03-.03-.05-.08-.14-.16-.27-.24-.41,0,0-.01-.01-.02-.02-.09-.14-.19-.27-.3-.4,0,0,0,0,0,0-.22-.27-.47-.51-.74-.73,0,0,0,0,0,0,0,0,0,0,0,0-.25-.2-.52-.38-.8-.54,0,0,0,0,0,0-.14-.07-.28-.15-.43-.21-.01,0-.03-.01-.04-.02-.14-.06-.27-.11-.41-.16-.03-.01-.06-.02-.1-.03-.13-.04-.25-.08-.38-.11-.05-.01-.11-.02-.16-.03-.11-.02-.22-.04-.33-.06-.09-.01-.18-.02-.27-.02-.08,0-.16-.02-.25-.02-.18,0-.35,0-.53,0-.18.01-.36.03-.53.06-.08.01-.17.03-.25.05-.09.02-.17.03-.26.05-.11.03-.22.06-.32.1-.05.02-.11.03-.16.05-.13.04-.25.1-.37.15-.03.01-.06.02-.09.04-.13.06-.27.13-.39.21-.01,0-.03.01-.04.02-.14.08-.27.17-.4.26,0,0,0,0,0,0-.26.19-.51.4-.73.63,0,0,0,0,0,0,0,0,0,0,0,0-.24.25-.46.52-.65.82,0,0,0,0,0,0-.09.14-.17.28-.25.43,0,0,0,.02-.01.03-.07.14-.13.28-.19.43,0,.02-.02.04-.02.06-.05.14-.1.28-.14.42,0,.03-.02.06-.03.09-.03.13-.06.27-.09.4,0,.04-.02.08-.02.12-.02.13-.03.27-.04.4,0,.04-.01.09-.01.13,0,.18,0,.36,0,.54.17,2.86,2.69,5.03,5.62,4.86,2.93-.17,5.17-2.63,5-5.49-.01-.18-.03-.36-.06-.54,0-.04-.02-.08-.03-.13Z"
                />
                <path
                    className="cls-1"
                    d="m80.25,32.42c-.03-.13-.05-.27-.09-.4-.01-.04-.02-.07-.04-.11-.04-.13-.08-.26-.13-.39,0-.02-.02-.05-.03-.07-.06-.14-.12-.27-.19-.41,0-.01-.02-.03-.02-.04-.08-.14-.16-.28-.24-.41,0,0,0,0,0-.01-.29-.43-.63-.81-1.03-1.14h0s0,0,0,0c-.38-.31-.8-.57-1.25-.77,0,0-.02,0-.03-.01-.14-.06-.29-.12-.44-.17-.02-.01-.05-.01-.08-.02-.13-.04-.27-.08-.41-.11-.05-.01-.1-.02-.15-.03-.11-.02-.23-.05-.35-.06-.09-.01-.18-.02-.26-.02-.09,0-.17-.02-.26-.02-.18,0-.35,0-.54,0-.18.01-.35.03-.52.06-.08.01-.15.03-.23.05-.09.02-.18.03-.27.06-.1.03-.2.06-.3.09-.06.02-.12.04-.18.06-.11.04-.22.09-.33.13-.04.02-.08.03-.12.05-.12.06-.24.12-.36.18-.02.01-.04.02-.06.03-.13.07-.25.15-.37.23,0,0-.02.01-.03.02-.13.09-.25.18-.36.28,0,0,0,0,0,0-.12.1-.24.21-.35.32,0,0,0,0,0,0,0,0,0,0,0,0-.13.13-.24.26-.35.39,0,0,0,0,0,0-.11.13-.21.27-.3.41,0,0,0,.01-.01.02-.09.14-.17.28-.25.42,0,.02-.02.03-.03.05-.07.14-.13.27-.19.42-.01.03-.02.05-.03.08-.05.13-.09.27-.13.4-.01.04-.02.07-.03.11-.03.13-.06.26-.09.39,0,.05-.02.09-.03.14-.02.13-.03.26-.04.4,0,.05-.01.09-.01.14,0,.18,0,.36,0,.55.17,2.86,2.69,5.03,5.62,4.86,2.93-.17,5.17-2.63,5-5.49-.01-.18-.03-.36-.06-.54,0-.04-.02-.08-.03-.12Z"
                />
            </g>
        </svg>
    );
};

export const registerEduplacesStatusFormatter = t => (cell, account) => {
    if (account.registered)
        return (
            <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                <span className="fa fa-check-circle-o text-success fa-lg" />
                {account.eduplacesId && eduplacesFormatter()}
            </div>
        );
    else
        return (
            <div style={{ display: 'flex', gap: '5px' }}>
                <span className="fa fa-times-circle-o text-danger fa-lg" />
                {account.eduplacesId && eduplacesFormatter()}
            </div>
        );
};

export const verifiedFormatter = t => (cell, account) => {
    if (cell)
        return (
            <span
                className="fa fa-check-circle-o text-success fa-lg"
                title={t('administration.verified_info', {
                    date: moment(account.verifiedAt).format(),
                    email: account.verifiedBy.email,
                    verificationComment: account.verificationComment,
                })}
            />
        );
    else return <span className="fa fa-times-circle-o text-danger fa-lg" title={t('customer_details.not_verified')} />;
};

export const dateFormatterShort = (date, t) => (date ? `${moment(date).format('DD.MM.YYYY')}` : '-');

export const statusFormatter = cell => {
    if (cell) return <span className="fa fa-check-circle-o text-success fa-lg" />;
    else return <span className="fa fa-times-circle-o text-danger fa-lg" />;
};

export const renderCustomerDetails = (t, customer, contactData, onChangeTaskContactData) => {
    return (
        <div>
            <div className="calculations-details-header">
                <h5>{t('customer_details.customer_information')}</h5>
            </div>
            <table className="table table-striped voffset">
                <thead>
                    <tr>
                        <th>{t('customer_details.contact_data')}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="col-md-3">{t('contact_data.gender')}</td>
                        <td className="col-md-9">{genderName(t, contactData.gender)}</td>
                    </tr>
                    <tr>
                        <td className="col-md-3">{t('common_phrases.name')}</td>
                        <td className="col-md-9">
                            {contactData.fullName}
                            {onChangeTaskContactData && (
                                <button
                                    type="button"
                                    className="btn btn-xs transparent"
                                    title={t('customer_details.edit_name')}
                                    onClick={onChangeTaskContactData}>
                                    <span className="glyphicon glyphicon-pencil text-info" />
                                </button>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td className="col-md-3">{t('customer_details.address')}</td>
                        <td className="col-md-9">{contactData.address}</td>
                    </tr>
                    <tr>
                        <td className="col-md-3">{t('customer_details.email')}</td>
                        <td className="col-md-9">{contactData.email || customer.email}</td>
                    </tr>
                    <tr>
                        <td className="col-md-3">{t('customer_details.tel_number')}</td>
                        <td className="col-md-9">{contactData.phone}</td>
                    </tr>
                </tbody>
            </table>

            {customer && (
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>{t('customer_details.customer_group')}</th>
                        </tr>
                    </thead>
                    {customer.customerGroup.type === CustomerGroupType.PRIVATE ? (
                        <tbody>
                            <tr>
                                <td className="col-md-3">{t('customer_details.customer_group')}</td>
                                <td className="col-md-9">{t(`customer_groups.id.${customer.customerGroup.id}`)}</td>
                            </tr>
                        </tbody>
                    ) : (
                        <tbody>
                            <tr>
                                <td className="col-md-3">{t('customer_details.customer_group')}</td>
                                <td className="col-md-9">{t(`customer_groups.id.${customer.customerGroup.id}`)}</td>
                            </tr>
                            <tr>
                                <td className="col-md-3">{t('customer_details.organisation')}</td>
                                <td className="col-md-9">{customer.organizationName}</td>
                            </tr>
                            <tr>
                                <td className="col-md-3">{t('common_phrases.location')}</td>
                                <td className="col-md-9">
                                    {customer.organizationLocation != null ? customer.organizationLocation.address : ''}
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            )}

            {customer && (
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>{t('customer_details.account')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="col-md-3">{t('contact_data.username')}</td>
                            <td className="col-md-9">{customer.email}</td>
                        </tr>
                        <tr>
                            <td className="col-md-3">{t('customer_details.registered')}</td>
                            <td className="col-md-9">
                                {statusFormatter(customer.registered)}{' '}
                                {customer.registered && dateFormatter(customer.registeredAt, t)}
                            </td>
                        </tr>
                        <tr>
                            <td className="col-md-3">{t('customer_details.verified')}</td>
                            <td className="col-md-9">
                                {statusFormatter(customer.verified)}{' '}
                                {customer.verified && dateFormatter(customer.verifiedAt, t)}
                            </td>
                        </tr>
                        <tr>
                            <td className="col-md-3">{t('customer_details.newsletter')}</td>
                            <td className="col-md-9">{statusFormatter(customer.subscribedToNewsletter)}</td>
                        </tr>
                    </tbody>
                </table>
            )}
        </div>
    );
};
